<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Folder info</template>

    <Sheet.Body class="pt-[25px]">
      <div
        class="mb-6 flex h-[176px] w-full items-center justify-center rounded-md bg-[#FAFAFA] p-[9px]"
      >
        <div class="size-[140px]">
          <Thumbnail type="folder" />
        </div>
      </div>

      <div
        v-for="(info, index) in folderInformation"
        :key="index"
        class="flex h-[30px] w-full items-center justify-between border-b border-[#E5E5E5] text-[12px] leading-[16px] text-gray-800"
      >
        <div class="opacity-60">{{ info.label }}</div>
        <div class="font-secondary">{{ info.value }}</div>
      </div>
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Sheet, Thumbnail, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'
import type { Folder } from '@/shared/graphql/router/graphql'
import { formatTimestamp } from '@/shared/utils/datetime'

const { close } = useSheet()

const props = defineProps<{
  folder: Folder
}>()

const folderInformation = computed(() => [
  {
    label: 'Number of files',
    value: props.folder.totalFiles,
  },
  ...(props.folder.createdAt
    ? [
        {
          label: 'Created',
          value: formatTimestamp(props.folder.createdAt),
        },
      ]
    : []),
])
</script>
